import { render, staticRenderFns } from "./CoursePackageManagement.vue?vue&type=template&id=5e232eb8&scoped=true&"
import script from "./course-package-management.js?vue&type=script&lang=js&"
export * from "./course-package-management.js?vue&type=script&lang=js&"
import style0 from "./CoursePackageManagement.vue?vue&type=style&index=0&id=5e232eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e232eb8",
  null
  
)

export default component.exports